<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="编号" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.small_project_id" clearable filterable placeholder="零星项目">
                                        <Option :value="item.small_project_id" v-for="(item,index) in projectList" :key="index">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.maintain_id" clearable filterable placeholder="维保记录">
                                        <Option :value="item.maintain_id" v-for="(item,index) in maintainList" :key="index">{{item.title}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.mode" clearable placeholder="类型">
                                        <Option :value="item.id" v-for="(item,index) in modeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.company_id" clearable filterable placeholder="供应商">
                                        <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.apply_id" clearable filterable placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建支出</Button>
                                        <Button v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2" type="success" size="small" class="text-font-sm" @click="exportData"><Icon type="md-paper-plane" /> 导出数据</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="expend_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #sn="{ row }">
                                    <div class="d-width cursor text-primary" :title="row.sn" @click="showData(row.expend_id)">
                                        <span>{{row.sn}}</span>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <span>{{row.money}}</span>
                                </template>
                                <template #tax_rate="{ row }">
                                    <span>{{row.tax_rate}} %</span>
                                </template>
                                <template #mode="{ row }">
                                    <Tag :color="row.mode === 2 ? 'orange' : 'blue'">{{row.mode_name}}</Tag>
                                </template>
                                <template #customer_name="{ row }">
                                    <div class="d-width" :title="row.customer_name">
                                        {{row.customer_name}}
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div class="d-width" :title="row.company">
                                        {{row.company}}
                                    </div>
                                </template>
                                <template #small_project_id="{ row }">
                                    <div class="d-width" :title="row.project_name">
                                        <span>{{row.project_name}}</span>
                                    </div>
                                </template>
                                <template #maintain_id="{ row }">
                                    <div class="d-width" :title="row.maintain_title">
                                        <span>{{row.maintain_title ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 5" color="orange" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 4 || row.status === 6" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #is_invoice="{ row }">
                                    <Badge v-if="row.is_invoice === 1" color="#999999" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 2" color="orange" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 3" color="blue" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
                                    <Badge v-else color="#999999" text="-" />
                                </template>
                                <template #apply_id="{ row }">
                                    <div class="d-width" :title="row.apply_name">
                                        <span>{{row.apply_name}}</span>
                                    </div>
                                </template>
                                <template #pay_money="{ row }">
                                    <div class="d-width text-success" :title="row.pay_money">
                                        <span>{{row.pay_money ? row.pay_money : '-'}}</span>
                                    </div>
                                </template>
                                <template #pay_time="{ row }">
                                    <span>{{!!row.pay_time?row.pay_time:'-'}}</span>
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        <span>{{row.remark ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) " @click="examineData(row.expend_id)">审批</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) "/>
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 " @click="payData(row.expend_id)">打款</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 "/>
                                    <a class="text-font-sm text-primary" v-if="row.status !== 7" @click="editData(row.expend_id)">编辑</a>
                                    <Divider type="vertical" v-if="row.status !== 7"/>
                                    <a class="text-font-sm text-danger" v-if="row.status !== 7" @click="deleteData(row.expend_id, index)">删除</a>
                                    <a class="text-font-sm text-success" v-if="row.status === 7" @click="showData(row.expend_id)">查看</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 支出审批  -->
                    <examine-modal v-if="is_examine" ref="ExamineRef" @trueHandler="saveData"></examine-modal>

                    <!-- 财务打款  -->
                    <pay-modal v-if="is_pay" ref="PayRef" @trueHandler="saveData"></pay-modal>

                    <!-- 支出详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 导出数据  -->
                    <Modal
                        v-model="is_export"
                        title="导出数据"
                        @on-ok="onExport"
                        :loading="export_loading"
                        width="800px"
                        ok-text="立即导出"
                        @on-cancel="cancelExport">
                        <Row :gutter="32">
                            <Col :span="24">
                                <Form label-position="left">
                                    <Row :gutter="32">
                                        <Col :span="12">
                                            <FormItem label="零星项目">
                                                <Select v-model="ExportForms.small_project_id" clearable filterable placeholder="选择零星项目">
                                                    <Option :value="item.small_project_id" v-for="(item,index) in projectList" :key="index">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="维保记录">
                                                <Select v-model="ExportForms.maintain_id" clearable filterable placeholder="选择维保记录">
                                                    <Option :value="item.maintain_id" v-for="(item,index) in maintainList" :key="index">{{item.title}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="类型">
                                                <Select v-model="ExportForms.mode" clearable placeholder="选择类型">
                                                    <Option :value="item.id" v-for="(item,index) in modeList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="供应商">
                                                <Select v-model="ExportForms.company_id" clearable filterable placeholder="选择供应商">
                                                    <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请人">
                                                <Select v-model="ExportForms.apply_id" clearable filterable placeholder="选择申请人">
                                                    <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="状态">
                                                <Select v-model="ExportForms.status" clearable placeholder="选择状态">
                                                    <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./ExpendCreate";
import ExamineModal from "./ExpendExamine";
import PayModal from "./ExpendPay";
import ShowModal from "./ExpendShow";
import {deleteDispersedExpend, exportDispersedExpend, getDispersedExpendConfig, getDispersedExpendList} from "@/apis/dispersed";
export default {
    name: "DispersedExpend",
    components: {
        Headers, Side, AddModal, ExamineModal, PayModal, ShowModal
    },
    data () {
        return {
            projectList: [],
            maintainList: [],
            modeList: [],
            companyList: [],
            userList: [],
            statusList: [],
            //导出文件由API端生成，前缀使用API地址
            site_url : this.$siteApi,

            search: {
                name: '',
                small_project_id: '',
                maintain_id: '',
                mode: '',
                company_id: '',
                apply_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    fixed:'left',
                    width : 160
                },
                {
                    title: '不含税金额',
                    key: 'money',
                    slot: 'money',
                    width: 110
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate',
                    width: 90
                },
                {
                    title: '税费',
                    key: 'tax_money',
                    width: 100
                },
                {
                    title: '含税金额',
                    key: 'true_money',
                    width: 110
                },
                {
                    title: '类型',
                    key: 'mode',
                    slot: 'mode',
                    width: 90
                },
                {
                    title: '零星项目',
                    key: 'small_project_id',
                    slot: 'small_project_id',
                    minWidth:160
                },
                {
                    title: '甲方',
                    key: 'customer_name',
                    slot: 'customer_name',
                    minWidth:160
                },
                {
                    title: '维保记录',
                    key: 'maintain_id',
                    slot: 'maintain_id',
                    minWidth:140
                },
                {
                    title: '供应商',
                    key: 'company',
                    slot: 'company',
                    minWidth:160
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                    width: 120
                },
                {
                    title: '发票状态',
                    key: 'is_invoice',
                    slot: 'is_invoice',
                    width: 110
                },
                {
                    title: '申请人',
                    key: 'apply_id',
                    slot: 'apply_id',
                    width: 100
                },
                {
                    title: '已付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                    width: 100
                },
                {
                    title: '付款时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                    width: 110
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    minWidth:120
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    fixed : 'right',
                    width : 180
                }
            ],
            is_create : false,
            is_examine : false,
            is_pay : false,
            is_show : false,
            is_export : false,
            export_loading : false,
            ExportForms : {
                small_project_id: '',
                maintain_id: '',
                mode: '',
                company_id: '',
                apply_id: '',
                status: ''
            }
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         * 功能：打开导出弹窗
         * time: 2026/10/06
         **/
        exportData(){
            let that = this;
            //默认带入当前列表搜索条件
            that.ExportForms = {
                small_project_id: that.search.small_project_id || '',
                maintain_id: that.search.maintain_id || '',
                mode: that.search.mode || '',
                company_id: that.search.company_id || '',
                apply_id: that.search.apply_id || '',
                status: that.search.status || ''
            };
            that.is_export = true;
        },
        /**
         * 功能：确认导出
         * time: 2026/10/06
         **/
        onExport(){
            let that = this;
            that.export_loading = true;
            exportDispersedExpend({search: that.ExportForms}).then(e => {
                that.$Message.success({ background: true, duration: 3, content: e.msg });
                if(e.data && e.data.url){
                    const fileUrl = that.site_url + e.data.url;
                    const parts = fileUrl.split('/');
                    const fileName = parts[parts.length - 1];
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.target = '_blank';
                    link.setAttribute('download', fileName);
                    link.click();
                }else{
                    that.$Message.error({ background: true, duration: 3, content: '没有文件可下载' });
                }
                that.cancelExport();
            }).finally(() => {
                that.export_loading = false;
            })
        },
        /**
         * 功能：关闭导出弹窗
         * time: 2026/10/06
         **/
        cancelExport(){
            let that = this;
            that.is_export = false;
            that.export_loading = false;
            that.ExportForms = {
                small_project_id: '',
                maintain_id: '',
                mode: '',
                company_id: '',
                apply_id: '',
                status: ''
            };
        },
        /**
         功能：搜索
         time: 2026/09/12
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：刷新
         time: 2026/09/12
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                small_project_id: '',
                maintain_id: '',
                mode: '',
                company_id: '',
                apply_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        getConfig(){
            let that = this;
            getDispersedExpendConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.maintainList = e.data.maintainList ?? [];
                that.modeList = e.data.modeList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         功能：列表
         time: 2026/09/12
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getDispersedExpendList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2026/09/12
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：创建
         time: 2026/09/12
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        editData(expend_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(expend_id);
            })
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        showData(expend_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(expend_id);
            })
        },
        /**
         功能：审批
         time: 2026/09/12
         **/
        examineData(expend_id){
            let that = this;
            that.is_examine = true;
            setTimeout(function(){
                that.$refs.ExamineRef.show(expend_id);
            })
        },
        /**
         功能：打款
         time: 2026/09/12
         **/
        payData(expend_id){
            let that = this;
            that.is_pay = true;
            setTimeout(function(){
                that.$refs.PayRef.show(expend_id);
            })
        },
        /**
         功能：操作返回
         time: 2026/09/12
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：删除
         time: 2026/09/12
         **/
        deleteData(expend_id, index){
            let that = this;
            if(!expend_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteDispersedExpend(expend_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
